import type React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  fill?: string;
}

export const CommentIcon: React.FC<IconProps> = ({
  size = 18,
  className,
  fill = 'currentColor',
}) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18,1C9.164,1,2,7.269,2,15C2,19.419,4.345,23.354,8,25.919V33L15.009,28.747C15.979,28.907,16.977,29,18,29C26.836,29,34,22.732,34,15C34,7.269,26.836,1,18,1"
      fill={fill}
      transform="translate(-2, -1) scale(0.9412)"
    />
  </svg>
);

export const RepostIcon: React.FC<IconProps> = ({
  size = 18,
  className,
  fill = 'currentColor',
}) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 8H9V4.8198L5.15728 4.05126C4.98683 4.01717 4.81343 4 4.63961 4C3.18179 4 2 5.18179 2 6.63961V9H0V6.63961C0 4.07722 2.07722 2 4.63961 2C4.94514 2 5.24992 2.03018 5.54951 2.0901L9 2.7802V0H10L14 4L10 8Z"
      fill={fill}
    />
    <path
      d="M16 7V9.36039C16 11.9228 13.9228 14 11.3604 14C11.0549 14 10.7501 13.9698 10.4505 13.9099L7 13.2198V16H6L2 12L6 8H7V11.1802L10.8427 11.9487C11.0132 11.9828 11.1866 12 11.3604 12C12.8182 12 14 10.8182 14 9.36039V7H16Z"
      fill={fill}
    />
  </svg>
);

export const HeartIcon: React.FC<IconProps> = ({
  size = 18,
  className,
  fill = 'currentColor',
}) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.24264 8.24264L8 15L14.7574 8.24264C15.553 7.44699 16 6.36786 16 5.24264V5.05234C16 2.8143 14.1857 1 11.9477 1C10.7166 1 9.55233 1.55959 8.78331 2.52086L8 3.5L7.21669 2.52086C6.44767 1.55959 5.28338 1 4.05234 1C1.8143 1 0 2.8143 0 5.05234V5.24264C0 6.36786 0.44699 7.44699 1.24264 8.24264Z"
      fill={fill}
    />
  </svg>
);

export const BookmarkIcon: React.FC<IconProps> = ({
  size = 18,
  className,
  fill = 'currentColor',
}) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2 0H14V16H12L8 12L4 16H2V0Z" fill={fill} />
  </svg>
);
